import _ from "lodash";

export function buildTensionerOverlay({ observation }) {
    if (!("overlay_data" in observation)) {
        return [];
    }

    const { stanchion_bbox, tensioner_bbox, temperature_celsius, stanchion_height_metre, min_upward_movement_metre, min_downward_movement_metre } =
        observation.overlay_data;

    const overlays = [];

    const midPointDistance = _.get(observation, ["class_specific_data", "estimated_mp_distance"], "Unknown");

    if (stanchion_bbox.length === 4) {
        const [left, top, width, height] = stanchion_bbox;
        const scale = height / stanchion_height_metre;
        const upperThreshold = Math.floor(min_upward_movement_metre * scale);
        const lowerThreshold = Math.floor(height - min_downward_movement_metre * scale);

        overlays.push(
            {
                type: "rect",
                left,
                top,
                width,
                height,
                options: {
                    stroke: "rgba(255, 255, 255, 0.5)",
                    strokeWidth: 1,
                    fill: "transparent",
                },
            },
            {
                type: "rect",
                left,
                top,
                width,
                height: upperThreshold,
                options: {
                    stroke: "transparent",
                    fill: "rgba(255, 0, 0, 0.2)",
                },
            },
            {
                type: "rect",
                left,
                top: top + upperThreshold,
                width,
                height: lowerThreshold - upperThreshold,
                options: {
                    stroke: "transparent",
                    fill: "rgba(0, 255, 0, 0.2)",
                },
            },
            {
                type: "rect",
                left,
                top: top + lowerThreshold,
                width,
                height: height - lowerThreshold,
                options: {
                    stroke: "transparent",
                    fill: "rgba(255, 0, 0, 0.2)",
                },
            },
            {
                type: "textbox",
                text: `MP Distance: ${midPointDistance}m\nTemperature: ${temperature_celsius}°C`,
                padding: 4,
                position: {
                    left: 0,
                    top: 0,
                },
                textOptions: {
                    fontFamily: "Helvetica",
                    fontSize: 12,
                    fontWeight: 500,
                    lineHeight: 1.05,
                    charSpacing: 60,
                    fill: "rgba(255, 255, 255, 1)",
                },
                rectOptions: {
                    fill: "rgba(0, 0, 0, 0.75)",
                },
            },
        );
    }

    if (tensioner_bbox.length === 4) {
        const [left, top, width, height] = tensioner_bbox;

        overlays.push({
            type: "rect",
            left,
            top,
            width,
            height,
            options: {
                stroke: "rgba(255, 255, 255, 1)",
                strokeWidth: 2,
                fill: "transparent",
            },
        });
    }
    return overlays;
}
